import React from "react";
import axios from "axios";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export default function useNewsletterSubscriptions() {
    const [subscriptions, setSubscriptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const fetchSubscriptions = React.useCallback(async ({ q = "", status = "all" } = {}) => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/newsletter/subscriptions`, {
                params: {
                    q: q || undefined,
                    status: status === "all" ? undefined : status,
                },
                withCredentials: true,
            });
            setSubscriptions(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(e?.response?.data?.error || e.message || "Newsletter-Anmeldungen konnten nicht geladen werden.");
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchSubscriptions();
    }, [fetchSubscriptions]);

    const setSubscriptionActive = async (id, isActive, filters = {}) => {
        const res = await axios.put(
            `${API_BASE}/api/newsletter/subscriptions/${id}/status`,
            { is_active: !!isActive },
            { withCredentials: true }
        );
        await fetchSubscriptions(filters);
        return res.data;
    };

    return { subscriptions, loading, error, fetchSubscriptions, setSubscriptionActive };
}
